import moment from "moment";
import VConsole from 'vconsole'
import { inDevelop } from '@/config'
import api from '@/api'
import { uploadConfig } from 'web-components'
import { message } from 'ant-design-vue';



export const copy = o => JSON.parse(JSON.stringify(o))
export const inMobile = /(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent)

export function debounce(fn, wait = 500) {
    var timer = null;
    return function () {
        timer && clearTimeout(timer);
        timer = setTimeout(fn, wait);
    }
}

export function throttle(func, delay = 500) {
    var prev = Date.now();
    return function () {
        var context = this;
        var args = arguments;
        var now = Date.now();
        if (now - prev >= delay) {
            func.apply(context, args);
            prev = Date.now();
        }
    }
}

export function dateFormat(timestamp, formatter) {
    return /^\d+$/.test(timestamp) ? moment(timestamp * 1000).format(formatter) : timestamp;
}

export function getCookie(name) {
    var arr = document.cookie.split("; ");
    for (var i = 0; i < arr.length; i++) {
        var arr2 = arr[i].split("=");
        if (arr2[0] == name) {
            return arr2[1];
        }
    }
    return "";
}

export function setCookie(name, value) {
    document.cookie = name + "=" + value + ";path=/";
}

export function removeCookie(name) {
    document.cookie = name + "=;path=/;expires=-1";
}

export function clearCookie() {
    var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
    if (keys) {
        for (var i = keys.length; i--;) {
            document.cookie = keys[i] + '=0;path=/;expires=' + new Date(0).toUTCString()
        }
    }
}

export const upload = async (file, params = {}, options = {}) => {
	params.fileName = file.name
	const response = await api.get("/buckets/credentials", {params:{...params}}, options);
	if (response && response.code == 200) {
		return uploadConfig(file, response.data, () => {
            message.warning('上传失败，请稍后再试');
		}, {
			qiniu: "/web/qiniu.min.js",
			aws: "/web/aws-sdk.min.js",
			baidubce: "/web/baidubce-sdk.bundle.min.js",
			oss: "/web/aliyun-oss-sdk.min.js",
			cos: "/web/cos-js-sdk-v5.min.js",
		})
	}
	return Promise.reject(false);
}